import React from "react";
import "../../../../../Assets/Styles/SimpleTextInput.scss";

const SimpleTextInput = (props) => {
  const transformPlaceHolder = () => {
    document.getElementById(props.Id).classList.add("active");
    document
      .getElementById(props.Id + "-placeholder")
      .classList.add("focused-state");
    addActiveState();
  };
  const putPlaceHolderBack = () => {
    if (document.getElementById(props.Id).value.length === 0) {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.remove("focused-state");
      removeActiveState();
    } else {
      document.getElementById(props.Id).classList.remove("active");
      document.getElementById(props.Id).classList.add("filled");
    }
    document
      .getElementById(props.Id + "-label-holder")
      .classList.remove("wrong");
  };
  const addActiveState = () => {
    document.getElementById(props.Id).classList.add("active");
  };
  const removeActiveState = () => {
    document.getElementById(props.Id).classList.remove("active");
  };
  return (
    <label id={props.Id + "-label-holder"} className="cx-simple-text-input">
      <p className="placeholder" id={props.Id + "-placeholder"}>
        {props.PlaceHolder}
      </p>
      <input
        onFocus={() => transformPlaceHolder()}
        onBlur={() => putPlaceHolderBack()}
        type="text"
        id={props.Id}
        className="cx-text-input"
        onChange={() => props.ChangeEvent()}
      />
      <p className="validation-message">{props.ValidationMessage} </p>
    </label>
  );
};
export default SimpleTextInput;
